// extracted by mini-css-extract-plugin
module.exports = {"muted":"Text_muted__3xLSX","left":"Text_left__6j30Q","right":"Text_right__1Nytx","center":"Text_center__2qNqZ","small":"Text_small__3LtoR"};